import { FC, useState } from 'react';

import { EditIcon, ExportIcon, EyeIconSmall, TrashBinIcon } from '../../../assets/icons/index';
import { Actions } from '../../../components/actions/index';
import { AlertDialogWrapper } from '../../../components/alert-dialog/index';
import { DividendPayout } from '../../../hooks/dividend/dividend.types';
import { DividendHooks } from '../../../hooks/index';
import { getTranslation } from '../../../utils/get-translation.util';
import { DividendDeleteModal } from './dividend-delete-modal';

type Props = {
  onEdit: (payout: DividendPayout) => void;
  onView: (payout: DividendPayout) => void;
  payout: DividendPayout;
};

export const DividendActionsMenu: FC<Props> = ({ payout, onView, onEdit }) => {
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);
  const { deletePayout, isPending } = DividendHooks.useDividendDelete();
  const { exportPayout } = DividendHooks.useDividendExport();

  const handleDelete = () => {
    deletePayout({ id: payout.id }, { onSuccess: () => setIsDeleteOpen(false) });
  };

  return (
    <>
      <AlertDialogWrapper control={{ onOpenChange: setIsDeleteOpen, open: isDeleteOpen }}>
        <DividendDeleteModal
          isPending={isPending}
          name={payout.name}
          onClose={() => setIsDeleteOpen(false)}
          onSuccess={handleDelete}
          status={payout.status}
        />
      </AlertDialogWrapper>

      <Actions
        actions={[
          {
            callback: () => onView(payout),
            icon: <EyeIconSmall className="size-4" />,
            title: getTranslation('VIEW_DETAILS'),
          },
          {
            attributes: { 'data-permission-required': true },
            callback: () => onEdit(payout),
            disabled: payout.isLocked,
            icon: (
              <EditIcon className="size-4" iconColor={payout.isLocked ? '#D0D5DD' : '#344054'} />
            ),
            title: getTranslation('EDIT_DETAILS'),
            tooltipContent: getTranslation('PAYOUT_EDIT_LOCKED'),
          },
          {
            callback: () => exportPayout({ payoutId: payout.id }),
            icon: <ExportIcon className="size-4" />,
            title: getTranslation('EXPORT_PAYOUT'),
          },
          {
            attributes: { 'data-permission-required': true },
            callback: () => setIsDeleteOpen(true),
            className: payout.isLocked ? undefined : 'text-fireside-600',
            disabled: payout.isLocked,
            icon: (
              <TrashBinIcon
                className="size-4"
                iconColor={payout.isLocked ? '#D0D5DD' : '#F04438'}
              />
            ),
            title: getTranslation('DELETE'),
            tooltipContent: getTranslation('PAYOUT_DELETE_LOCKED'),
          },
        ]}
      />
    </>
  );
};
